
import { IMapType, Instance, IType, types } from 'mobx-state-tree';
import { IEntity } from '../main/entities';
import { commSvc, IOcResponse } from '../services/CommSvc';
import { toasterSvc } from '../services/ToasterSvc';
import { getOmnistore } from './Omnistore';

export const EntityUpserter = types
	.model('EntityUpserter', {
		_storeId: types.string,
		_isSyncing: types.boolean,
		_entityClassName: types.string,
		_masterId: types.number,
		_pending: types.array(types.frozen<IEntity>()),
	})
	.views(self => ({
		get _store() {
			return getOmnistore().entityManagerStore.byStoreId(self._storeId);
		},
		allAsList(map: Instance<IMapType<IType<IEntity, IEntity, IEntity>>>) : Array<IEntity> {
			if (!self._pending.length) return [...map.values()];
			const m = {};
			for (let e of map.values()) m[e.id] = e;
			for (let e of self._pending.values()) m[e.id] = e;
			return Object.values(m);
		},
	}))
	.actions(self => ({
		clear() {
			self._pending.length = 0;
		},
		_add(entity: IEntity) : void {
			self._pending.push(entity);
		},
		_remove(entity: IEntity) : void {
			const i = self._pending.indexOf(entity);
			if (i === -1) throw new Error('Entity not found: ' + entity.id);
			self._pending.splice(i, 1);
		},
		_path(action: 'Create' | 'Update' | 'Delete'| 'Put') : string {
			const className = self._entityClassName;
			switch (className) {
			case 'AdmAd': return action + 'Advertisement';
			}
			return action + className;
		},
	}))
	.views(self => ({
		_doPost(entity: {[s: string] : any}, action: 'Create' | 'Update' | 'Delete'| 'Put') : Promise<IOcResponse> {
			if (action==='Update' && self._isSyncing) return commSvc.doPost('UpdateTemplateItems', {
				syncingCode: self._store.etag,
				templateId: self._masterId,
				items: [entity],
			});
			return commSvc.doPost(self._path(action), entity);
		}
	}))
	.actions(self => ({
		_execute(entity: {[s: string] : any}, action: 'Create' | 'Update' | 'Delete' | 'Put') : Promise<IEntity> {
			const {timestamp, ...e} = entity as any;
			self._add(e);

			let ok = false;
			return self._doPost(e, action)
				.then(r => {
					ok = !!r.outputList;
					return r;
				})
				.then(toasterSvc.failure)
				.then(() => self._store.fetchDirect())
				.finally(() => self._remove(e))
				.then(() => ok ? Promise.resolve(e) : Promise.reject());
		},
	}))
	.actions(self => ({
		create(entity: IEntity) : Promise<IEntity> {
			const {id, ...e} = entity;
			return self._execute(e, 'Create');
		},
		update(entity: IEntity) : Promise<IEntity> {
			return self._execute(entity, 'Update');
		},
		put(entity: IEntity) : Promise<IEntity> {
			const e = {...entity, id: entity.id || null};
			return self._execute(e, 'Put');
		},
		delete(entity: IEntity) : Promise<IEntity> {
			return self._execute({_: entity.id}, 'Delete');
		},
	}));
